import { getSubtypeAds } from 'site-modules/upper-funnel/pages/subtype/get-subtype-ads';

export const getIndicesLength = subtypeAdPlacementIndices => {
  if (!subtypeAdPlacementIndices.length) return null;
  return subtypeAdPlacementIndices[subtypeAdPlacementIndices.length - 1].endIndex;
};

export const getSubtypeOverflowAdPos = (length, trkParam, isMobile) => {
  const ads = [];
  const subtypeAds = getSubtypeAds(trkParam, isMobile, false, '3rem');
  /**
   * Reference: Original overflow logic:
   * if (length < 3) ads.push(subtypeAds.pos1);
   * if (length < 6) ads.push(subtypeAds.pos2);
   * if (length < 9) ads.push(subtypeAds.segmentListing);
   * if (length < 12) ads.push(subtypeAds.videoAd);
   * if (length < 15) ads.push(subtypeAds.filmstrip);
   * if (length < 18) ads.push(subtypeAds.pos3);
   * if (length < 21) ads.push(subtypeAds.pos4);
   */
  if (length < 9) ads.push(subtypeAds.segmentListing);
  if (length < 15) ads.push(subtypeAds.filmstrip);

  return ads;
};
